const SintEustatiusSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112336)">
      <path
        d="M8.72803 36.5223C11.9379 38.7165 15.8189 40.0006 20.0004 40.0006C24.182 40.0006 28.0631 38.7165 31.2729 36.5223L20.0004 34.7832L8.72803 36.5223Z"
        fill="#D80027"
      />
      <path
        d="M31.2729 3.47828C28.0631 1.28414 24.182 0 20.0004 0C15.8189 0 11.9377 1.28414 8.72803 3.47828L20.0004 5.21742L31.2729 3.47828Z"
        fill="#D80027"
      />
      <path
        d="M8.72803 36.5223C11.9379 38.7165 15.8189 40.0006 20.0004 40.0006C24.182 40.0006 28.0631 38.7165 31.2729 36.5223L20.0004 34.7832L8.72803 36.5223Z"
        fill="#D80027"
      />
      <path
        d="M31.2729 3.47828C28.0631 1.28414 24.182 0 20.0004 0C15.8189 0 11.9377 1.28414 8.72803 3.47828L20.0004 5.21742L31.2729 3.47828Z"
        fill="#D80027"
      />
      <path
        d="M39.9485 18.6959C39.4747 12.5233 35.7242 6.52203 31.2719 3.47852H8.72705C3.79455 6.85047 0.448691 12.373 0.0415039 18.6959L19.9995 20.0003L39.9485 18.6959Z"
        fill="#0052B4"
      />
      <path
        d="M0.0415039 21.3044C0.448691 27.6274 3.79447 33.1498 8.72697 36.5218H31.2718C36.2046 33.1499 39.5502 27.6274 39.9574 21.3044L19.9995 20L0.0415039 21.3044Z"
        fill="#0052B4"
      />
      <path
        d="M39.9491 18.6953H21.3044V2.6084H18.6957V18.6953H0.0421094C0.014375 19.1265 0 19.5614 0 19.9997C0 20.4379 0.0142969 20.8728 0.0420313 21.304H18.6957V37.3911H21.3044V21.304H39.958C39.9857 20.8728 40 20.4379 40 19.9997C40 19.5646 39.9824 19.1296 39.9491 18.6953Z"
        fill="#D80027"
      />
      <path
        d="M7.82568 20.0004L19.9995 12.3486L32.1735 20.0004L19.9995 27.6521L7.82568 20.0004Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.0435 23.4772H28.6956L25.2174 18.2598L23.4782 19.9989L21.7391 19.1294L19.9999 21.738H16.5217L14.7825 19.9989L13.0435 23.4772Z"
        fill="#6DA544"
      />
      <path
        d="M19.9999 14.7832L20.4316 16.1117H21.8284L20.6983 16.9329L21.1301 18.2615L19.9999 17.4404L18.8697 18.2615L19.3015 16.9329L18.1714 16.1117H19.5682L19.9999 14.7832Z"
        fill="#FFDA44"
      />
      <path
        d="M19.9998 10.1611L4.34766 19.9991L19.9998 29.8371L35.652 19.9991L19.9998 10.1611ZM9.24984 19.9991L19.9998 13.2423L30.7498 19.9991L19.9998 26.7559L9.24984 19.9991Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112336">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SintEustatiusSvg;
